module.exports = __webpack_public_path__ + "static/media/Cradily_gaussian2.083a76e8.png";